import { RankMedal } from 'src/utils/types';
import { AppError } from 'src/redux/types';
export const parseRanking = rankLevel => {
  switch (rankLevel) {
    case RankMedal.TUTORIAL:
      {
        return 'Tutorial';
      }

    case RankMedal.RECRUIT:
      {
        return 'Recruit';
      }

    case RankMedal.PRIVATE:
      {
        return 'Private';
      }

    case RankMedal.BRONZE:
      {
        return 'Bronze';
      }

    case RankMedal.SILVER:
      {
        return 'Silver';
      }

    case RankMedal.GOLD:
      {
        return 'Gold';
      }

    case RankMedal.PLATINUM:
      {
        return 'Platinum';
      }

    case RankMedal.DIAMOND:
      {
        return 'Diamond';
      }

    case RankMedal.MASTER:
      {
        return 'Master';
      }

    case RankMedal.CHAMPION:
      {
        return 'Champion';
      }

    case RankMedal.SUPER_CHAMPION:
      {
        return 'Super Champion';
      }

    default:
      return '';
  }
};
export function formatErrorMessage(error) {
  switch (error) {
    case AppError.UNNKOWN:
      return 'Something went wrong.\nPlease try again later.';

    default:
      return `Error code ${error}`;
  }
}